import React, { Component } from 'react';
import Radium from 'radium';
import { greyScaleColors } from '../Globals/styles'

class Modal extends Component {
    render() {
        const { children, onClose, hide, overlayStyle, closeButtonStyle } = this.props;
        if(hide) return null
        else
        return (
            <div style={[styles.overlay, hide ? styles.hidden : styles.show, overlayStyle]}>
                <div key={1} style={styles.modalContent}>
                    <span style={[styles.close, closeButtonStyle]} onClick={onClose}>&times;</span>
                    {children}
                </div>
            </div>
        )
    }
}

var styles = {
    overlay: {
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: '0',
        left: '0',
        backgroundColor: greyScaleColors.grey,
        zIndex: '9999999999999',
    },
    hidden: {
        display: 'none',
    },
    show: {
        display: 'block',
    },
    close: {
        color: '#aaaaaa',
        fontSize: 28,
        fontWeight: 'bold',
        alignSelf: 'center',
        ':hover':
        {
            color: '#000',
            textDecoration: 'none',
            cursor: 'pointer',
        }
    },
    modalContent: {
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    }
}

export default Radium(Modal);


// WEBPACK FOOTER //
// ./src/App/Common/modal.jsx